module.exports = __webpack_public_path__ + "img/CJQ.ca960b44.jpg";